// export default ProductMap = {
exports.ProductMap = {
  54: {
    '2 kWh': [{
      name: 'Get Set Kit (2kWh)',
      pid: '7763555057905',
      varId: '43104481247473',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '3898',
      old_price: '4898',
      save_money: '1000',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '1 x Batteria LFP da 2kWh', '1 x Pacchetto cavi'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'Il Get Set Kit ti permette di costruire rapidamente un sistema elettrico base per il tuo camper/la tua abitazione off-grid usando una batteria LFP e un Power Hub.'
    }, {
      name: 'Prepared Kit (2kWh)',
      pid: '7763555057905',
      varId: '43104481280241',
      adaptBatCap: '2-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '4398',
      old_price: '5468',
      save_money: '1070',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '1 x Batteria LFP da 2kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '1 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'Il Prepared Kit ti offre un maggiore controllo sul tuo consumo di energia, per una maggiore comodità e praticità durante i viaggi o nella vita off-grid.'
    }, {
      name: 'Independence Kit (2kWh)',
      pid: '7763555057905',
      varId: '43104481313009',
      adaptBatCap: '2-1',
      limit: 2,
      off_price: '4698',
      old_price: '5798',
      save_money: '1100',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '1 x Batteria LFP da 2kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '1 x Console di Power Kits',
      // '1 x Smart Generator',
      '1 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: "L'Independence Kit fornisce una soluzione energetica off-grid completa. Con il pannello di distribuzione intelligente CA/CC e la console per Power Kit di EcoFlow, puoi monitorare, controllare e personalizzare l'alimentazione dalla parete o dall'app per dispositivi mobili."
    }],
    '4 kWh': [{
      name: 'Get Set Kit (4kWh)',
      pid: '7763555221745',
      varId: '43104482459889',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '5597',
      old_price: '7097',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '2 x Batteria LFP da 2kWh', '1 x Pacchetto cavi'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'Il Get Set Kit ti permette di costruire rapidamente un sistema elettrico base per il tuo camper/la tua abitazione off-grid usando una batteria LFP e un Power Hub.'
    }, {
      name: 'Prepared Kit (4kWh)',
      pid: '7763555221745',
      varId: '43104482492657',
      adaptBatCap: '2-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '6097',
      old_price: '7667',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '2 x Batteria LFP da 2kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '2 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'Il Prepared Kit ti offre un maggiore controllo sul tuo consumo di energia, per una maggiore comodità e praticità durante i viaggi o nella vita off-grid.'
    }, {
      name: 'Independence Kit (4kWh)',
      pid: '7763555221745',
      varId: '43104482525425',
      adaptBatCap: '2-1',
      limit: 1,
      off_price: '6397',
      old_price: '7997',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '2 x Batteria LFP da 2kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '1 x Console di Power Kits',
      //  '1 x Smart Generator',
      '2 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: "L'Independence Kit fornisce una soluzione energetica off-grid completa. Con il pannello di distribuzione intelligente CA/CC e la console per Power Kit di EcoFlow, puoi monitorare, controllare e personalizzare l'alimentazione dalla parete o dall'app per dispositivi mobili."
    }],
    '5 kWh': [{
      name: 'Get Set Kit (5kWh)',
      pid: '7763555385585',
      varId: '43104483508465',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5998',
      old_price: '7498',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '1 x Batteria LFP da 5kWh', '1 x Pacchetto cavi'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'Il Get Set Kit ti permette di costruire rapidamente un sistema elettrico base per il tuo camper/la tua abitazione off-grid usando una batteria LFP e un Power Hub.'
    }, {
      name: 'Prepared Kit (5kWh)',
      pid: '7763555385585',
      varId: '43104483541233',
      adaptBatCap: '5-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '6498',
      old_price: '8068',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '1 x Batteria LFP da 5kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '1 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'Il Prepared Kit ti offre un maggiore controllo sul tuo consumo di energia, per una maggiore comodità e praticità durante i viaggi o nella vita off-grid.'
    }, {
      name: 'Independence Kit (5kWh)',
      pid: '7763555385585',
      varId: '43104483574001',
      adaptBatCap: '5-1',
      limit: 2,
      off_price: '6798',
      old_price: '8398',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '1 x Batteria LFP da 5kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '1 x Console di Power Kits',
      //  '1 x Smart Generator',
      '1 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: "L'Independence Kit fornisce una soluzione energetica off-grid completa. Con il pannello di distribuzione intelligente CA/CC e la console per Power Kit di EcoFlow, puoi monitorare, controllare e personalizzare l'alimentazione dalla parete o dall'app per dispositivi mobili."
    }],
    '10 kWh': [{
      name: 'Get Set Kit (10kWh)',
      pid: '7763555549425',
      varId: '43104483770609',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '9797',
      old_price: '12297',
      save_money: '2500',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '2 x Batteria LFP da 5kWh', '1 x Pacchetto cavi'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'Il Get Set Kit ti permette di costruire rapidamente un sistema elettrico base per il tuo camper/la tua abitazione off-grid usando una batteria LFP e un Power Hub.'
    }, {
      name: 'Prepared Kit (10kWh)',
      pid: '7763555549425',
      varId: '43104483803377',
      adaptBatCap: '5-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '10297',
      old_price: '12867',
      save_money: '2570',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '2 x Batteria LFP da 5kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '2 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'Il Prepared Kit ti offre un maggiore controllo sul tuo consumo di energia, per una maggiore comodità e praticità durante i viaggi o nella vita off-grid.'
    }, {
      name: 'Independence Kit (10kWh)',
      pid: '7763555549425',
      varId: '43104483836145',
      adaptBatCap: '5-1',
      limit: 1,
      off_price: '10597',
      old_price: '13197',
      save_money: '2600',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '2 x Batteria LFP da 5kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '1 x Console di Power Kits',
      //  '1 x Smart Generator',
      '2 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: "L'Independence Kit fornisce una soluzione energetica off-grid completa. Con il pannello di distribuzione intelligente CA/CC e la console per Power Kit di EcoFlow, puoi monitorare, controllare e personalizzare l'alimentazione dalla parete o dall'app per dispositivi mobili."
    }],
    '15 kWh': [{
      name: 'Get Set Kit (15kWh)',
      pid: '7763555713265',
      varId: '43104484098289',
      consoleChoose: 'Y',
      off_price: '13596',
      old_price: '17096',
      save_money: '3500',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '3 x Batteria LFP da 5kWh', '1 x Pacchetto cavi'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'Il Get Set Kit ti permette di costruire rapidamente un sistema elettrico base per il tuo camper/la tua abitazione off-grid usando una batteria LFP e un Power Hub.'
    }, {
      name: 'Prepared Kit (15kWh)',
      pid: '7763555713265',
      varId: '43104484131057',
      consoleChoose: 'Y',
      off_price: '14096',
      old_price: '17666',
      save_money: '3570',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '3 x Batteria LFP da 5kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '3 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'Il Prepared Kit ti offre un maggiore controllo sul tuo consumo di energia, per una maggiore comodità e praticità durante i viaggi o nella vita off-grid.'
    }, {
      name: 'Independence Kit (15kWh)',
      pid: '7763555713265',
      varId: '43104484163825',
      off_price: '14396',
      old_price: '17996',
      save_money: '3600',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Inizio agosto 2022',
      accessories: ['1 x Power Hub', '3 x Batteria LFP da 5kWh', '1 x Pacchetto cavi', '1 x Pannello di distribuzione intelligente CA/CC', '1 x Console di Power Kits',
      //  '1 x Smart Generator',
      '3 x Cinghia di montaggio per batteria'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: "L'Independence Kit fornisce una soluzione energetica off-grid completa. Con il pannello di distribuzione intelligente CA/CC e la console per Power Kit di EcoFlow, puoi monitorare, controllare e personalizzare l'alimentazione dalla parete o dall'app per dispositivi mobili."
    }]
  }
};
exports.solarPanelMap = {
  54: [{
    name: '2 * Pannello solare rigido da 100 W + 2 * Piedini di montaggio solari rigidi',
    pid: '7795661504753',
    varId: '43234286829809',
    old_price: '229',
    off_price: '179',
    save_money: '50',
    limit: 99,
    // discount: "%1=369%%2=729%%3=1089%%n={per=1,off=0}%",
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2 * Pannello solare rigido da 400 W + 4 * Piedini di montaggio solari rigidi',
    pid: '7843558523121',
    varId: '43419242135793',
    old_price: '799',
    off_price: '599',
    // tips: "*This item excludes free shipping.",
    save_money: '200',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1 * Pannello solare flessibile 100 W',
    pid: '7795654951153',
    varId: '43234258387185',
    old_price: '149',
    off_price: '129',
    save_money: '20',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }]
};
exports.BatteryMap = {
  54: [{
    name: 'Batteria LFP da 2 kWh + Staffa di montaggio + Cavo batteria',
    pid: '7844432478449',
    varId: '43421553164529',
    off_price: '1748',
    old_price: '2248',
    save_money: '500',
    capacity: '2-1',
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: 'Batteria LFP da 5 kWh + Staffa di montaggio + Cavo batteria',
    pid: '7844432478449',
    varId: '43421553197297',
    off_price: '3848',
    old_price: '4848',
    save_money: '1000',
    capacity: '5-1',
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }
  // {
  //     name: 'Batteria LFP da 2kWh',
  //     pid: '7844432478449',
  //     varId: '43421553098993',
  //     off_price: '1699',
  //     old_price: '2199',
  //     save_money: '500',
  //     capacity: 2,
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: 'Batteria LFP da 5kWh',
  //     pid: '7844432478449',
  //     varId: '43421553131761',
  //     off_price: '3799',
  //     old_price: '4799',
  //     save_money: '1000',
  //     capacity: 5,
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  // {
  //     name: 'Batteria LFP da 2kWh + Cinghia di montaggio per batteria',
  //     pid: '7844432478449',
  //     varId: '43421553164529',
  //     off_price: '1748',
  //     old_price: '2248',
  //     save_money: '500',
  //     capacity: '2-1',
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: 'Batteria LFP da 5kWh + Cinghia di montaggio per batteria',
  //     pid: '7844432478449',
  //     varId: '43421553197297',
  //     off_price: '3848',
  //     old_price: '4848',
  //     save_money: '1000',
  //     capacity: '5-1',
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  ]
};

// exports.InstallationMap = {
//     54: {
//         pid: '8430069023069',
//         varId: '46942631166301',
//         off_price: '0',
//         old_price: '0',
//         save_money: '0',
//     },
// };

exports.ConsoleMap = {
  54: [{
    name: 'Console di Power Kits EcoFlow',
    pid: '7747682795761',
    varId: '43041908654321',
    off_price: '349',
    old_price: '349',
    limit: 1,
    // save_money: '599',
    prdType: 'console',
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};
exports.ShopifyUrl = 'https://it.ecoflow.com/';